const ALLOWED_CONTROL_KEYS = [
  'Backspace',
  'Delete',
  'Tab',
  'Enter',
  'Escape',
  'ArrowLeft',
  'ArrowRight',
  'Home',
  'End',
];

const DATE_FORMAT = {
  SEPARATOR: '/',
  SLASH_POSITIONS: [2, 5],
  MAX_LENGTH: 10,
  DIGIT_PATTERN: /\d/,
};

const isControlAction = (event) => {
  const { key, ctrlKey, metaKey } = event;
  return ctrlKey || metaKey || ALLOWED_CONTROL_KEYS.includes(key);
};

const isMaxLengthReached = (event, maxLength) => {
  const { value, selectionStart, selectionEnd } = event.target;
  const isReplacingSelection = selectionStart !== selectionEnd;

  return value.length >= maxLength && !isReplacingSelection;
};

const isValidCharacterAtPosition = (event) => {
  const { key, target } = event;
  const position = target.selectionStart;
  const isSlashPosition = DATE_FORMAT.SLASH_POSITIONS.includes(position);

  return isSlashPosition ? key === DATE_FORMAT.SEPARATOR : DATE_FORMAT.DIGIT_PATTERN.test(key);
};

export const allowOnlyDateCharacters = (event, maxLength = DATE_FORMAT.MAX_LENGTH) => {
  if (isControlAction(event)) {
    return;
  }

  if (!isValidCharacterAtPosition(event) || isMaxLengthReached(event, maxLength)) {
    event.preventDefault();
  }
};
